// @flow
// $FlowFixMe - Cannot import useEffect because there is no useEffect export in react.
import React, { useEffect } from 'react';
import { SelectHookForm } from 'bench-internal-theme';
import { useLazyQuery } from '@apollo/client';
import { useFormContext } from 'react-hook-form';
import type { LedgerAccount } from '../types';
import { GET_FINANCIAL_INSTITUTION } from '../queries';
import { productTypeOptions } from './formOptions';

type ProductTypeSelectContainerProps = {
  isSubmitting: boolean,
  ledgerAccount: ?LedgerAccount,
  isTemporary: boolean,
};

const ProductTypeSelect = ({
  isSubmitting,
  ledgerAccount,
  isTemporary,
}: ProductTypeSelectContainerProps) => {
  const { watch } = useFormContext();
  const institution = watch('institution', undefined);
  const categoryId = watch('categoryId', undefined);

  const [getFinancialInstitution, { loading, error, data }] = useLazyQuery(
    GET_FINANCIAL_INSTITUTION,
    {
      fetchPolicy: 'cache-and-network',
    },
  );

  useEffect(() => {
    if (institution?.value) {
      getFinancialInstitution({
        variables: { id: institution?.value },
      });
    }
  }, [institution, getFinancialInstitution]);

  const products = data?.financialInstitution?.products || [];

  const productsForCategory =
    products.filter(product => {
      const productLedgerCategoryId = product?.financialInstitutionProductType?.ledgerCategory?.id;
      // For P/B ledgers, we allow any of the equity product types
      if (categoryId?.value === '9') return productLedgerCategoryId === '5';
      return productLedgerCategoryId === categoryId?.value;
    }) || [];

  const options = productTypeOptions(productsForCategory);

  const getNoOptionsMessage = () => {
    if (!institution?.value) {
      return 'Please select an institution';
    }
    return 'Please request a new product type in the #institution_admins slack channel';
  };

  return (
    <SelectHookForm
      name="productType"
      aria-label="Product Type"
      isDisabled={isSubmitting || !!error}
      isLoading={loading}
      placeholder={error && 'A problem occurred fetching products'}
      defaultValue={ledgerAccount?.financialInstitutionProduct?.id}
      options={options}
      rules={{ required: { value: !isTemporary, message: 'Product type is required' } }}
      noOptionsMessage={getNoOptionsMessage}
    />
  );
};

ProductTypeSelect.defaultProps = {
  ledgerAccount: undefined,
};

export default ProductTypeSelect;
